import React from 'react';

const Strategy = () => (
  <>
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <h1 className="fw-bold">Our Strategy</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>How we deliver excellence</p>
      </div>
    </section>

    <section className="py-5 bg-white">
      <div className="container py-4">
        <div className="row g-5">
          {[
            { icon: '🏗️', title: 'Business Model', desc: 'We operate on a client-centric model combining onshore and offshore delivery to maximize value. Our hybrid model ensures quality, speed, and cost-effectiveness for every engagement.' },
            { icon: '🔄', title: 'Process Methodology', desc: 'We follow Agile and Scrum methodologies with iterative development cycles, continuous feedback loops, and transparent communication to ensure projects are delivered on time and within budget.' },
            { icon: '✅', title: 'Quality Assurance', desc: 'Our ISO 9001:2000 certified QA process includes rigorous testing at every stage — unit testing, integration testing, UAT, and performance testing — ensuring zero-defect delivery.' },
            { icon: '🖥️', title: 'Development Infrastructure', desc: 'State-of-the-art development centers in USA and India with 24/7 operations, redundant systems, secure VPN access, and the latest development tools and technologies.' },
          ].map((s, i) => (
            <div key={i} className="col-12 col-md-6">
              <div className="card border-0 shadow-sm h-100 p-4 rounded-4">
                <div style={{ fontSize: 44 }} className="mb-3">{s.icon}</div>
                <h4 className="fw-bold text-primary mb-3">{s.title}</h4>
                <p className="text-muted">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default Strategy;
